import { useEffect } from "react";

const BASE = "Alpha Transfer";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export const Seo = ({ title, description, path = "", noindex = false }) => {
  useEffect(() => {
    const full = title.includes(BASE) ? title : `${title} | ${BASE}`;
    document.title = full;
    setMeta("name", "description", description);
    setMeta("property", "og:title", full);
    setMeta("property", "og:description", description);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = `${window.location.origin}${path}`;
  }, [title, description, path, noindex]);
  return null;
};
